import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=afb75c86&lang=pug&"
import script from "./BaseFooter.vue?vue&type=script&lang=js&"
export * from "./BaseFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports